import classes from './PreviewDeviceFrame.module.css';

// Wraps a preview in the device it is being previewed on. Two shapes, both
// already drawn by hand in the push-notification preview: a browser window
// with traffic lights and an address bar, and an iPhone — bezel and corner
// radius only, since anything drawn on the screen itself covers the block
// the author came to look at (see the stylesheet).
//
// It only draws the frame. What the block renders *at* — a 1200px desktop
// viewport or a 390px phone one — is `getPreviewFit`'s business, and the
// caller passes the same `device` to both; a bezel around a desktop-width
// render would be a lie about the only thing a device preview is for.
const PreviewDeviceFrame = ({ device, url, children }) => {
  // `app` is the same phone: what differs is the chrome drawn *inside* the
  // screen — the native SDKs' card and close control rather than the web
  // SDK's — and that is the preview's business, not the bezel's.
  if (device === 'mobile' || device === 'app') {
    return (
      <div className={classes.mobileHolder}>
        <div className={classes.mobile}>
          <div className={classes.screen}>{children}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.desktop}>
      <div className={classes.chrome}>
        <span className={classes.lights}>
          <span className={classes.light} />
          <span className={classes.light} />
          <span className={classes.light} />
        </span>
        {/* The merchant's own domain where we know it: the preview is of their
            shop, and an invented example.com reads as a mistake. */}
        <span className={classes.address}>{url || 'your shop'}</span>
      </div>
      {children}
    </div>
  );
};

export default PreviewDeviceFrame;
